import type { ElementType, HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/utils';

import styles from './Container.module.css';

export interface ContainerProps extends HTMLAttributes<HTMLElement> {
  /** Element to render — use `section`, `header`, `footer` etc. for semantics. */
  as?: ElementType;
  size?: 'default' | 'narrow' | 'wide';
  children: ReactNode;
}

/** Centres content and applies the shared page gutter. */
export function Container({
  as: Component = 'div',
  size = 'default',
  className,
  children,
  ...props
}: ContainerProps) {
  return (
    <Component className={cn(styles.container, styles[size], className)} {...props}>
      {children}
    </Component>
  );
}
